import { Card } from 'common';
import * as React from 'react';
export default {
  Card,
  React
};